import React from "react";
import { useOurApi } from "../../../hooks/useOurApi"
import  Spinner  from "../../Spinner/Spinner"
import MensajeError from '../../Mensajes/MensajeError'
import DatosPersonales from "./DatosPersonales"

import { useEffect, useState, useContext } from "react";
import { AppContext } from '../../../App'

export default function DatosPersonalesCtrl(){
    
  const {state, dispatch} = useContext(AppContext);

  const url = `${process.env.REACT_APP_API_AUTORIZACION_URL}/usuarioAutenticado`;
  const { data, isLoading, hasError } = useOurApi(url, {});

  useEffect(() => {
    if(data && (data.nif || data.razonSocial)) {      
      dispatch({ type: 'UPDATE_HAY_USUARIO_AUTENTICADO', data: data.nif.toUpperCase() + ' - ' + data.razonSocial.toUpperCase(),});
    }
  }, [data])

  if (isLoading) return <Spinner />;

  if (hasError){
    const mensaje={data:"Fallo obteniendo datos personales. Póngase en contacto con el soporte (soportec@navarra.es) para resolver el problema."};
    return <MensajeError mensaje={mensaje} />;
  }
    const datosPersonales={nif:data.nif,razonSocial:data.razonSocial};
  return  <>
    
    <div className="our-grid">
      <DatosPersonales datosPersonales={datosPersonales}></DatosPersonales>
    </div>
    </>
}